module.exports = __webpack_public_path__ + "fonts/Noto_Sans_TC-300-532.56ab398.woff2";